import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { FieldSalesPage } from '@/features/field-sales/pages/FieldSalesPage'

const searchSchema = z.object({
  tab: z.enum(['routes', 'assignments', 'dispatch', 'outlets', 'commission', 'visits', 'access']).catch('routes'),
})

export const Route = createFileRoute('/_app/field-sales/')({
  validateSearch: searchSchema,
  component: FieldSalesPage,
})
